<template>
     <div id="Tariff" style="float: right;width:100%;height: 100%;direction:rtl">
        <div class="card" style="float: right;width:100%;height: 100%">
            <div class="card-header">
                <h3 class="card-title"  > <CIcon name="cil-map" style="width: 20px;height: 20px"/>&nbsp;&nbsp;
                    عنوان روز
                </h3>
                <CButton @click="Add()"   color="outline-primary" style="float:left;border-bottom-left-radius: 2px;border-top-left-radius: 2px;border-top-right-radius: 2px;border-bottom-right-radius: 2px" title="افزودن" >افزودن</CButton>&nbsp;
            </div>
            <div class="card-body" style="float: right;width:100%;height: 100%;min-height: 450px">
                <CDataTable
                        :hover="true"
                        :border="true"
                        
                        :striped="true"
                        :small="true"
                        :items="$store.state.DayDefine_GetAll.RequestResponse"
                        :fields="fields"
                        :fixed="true"
                        :loading="false"
                        :items-per-page="10"
                        pagination
                        :noItemsView="{ noResults: 'چیزی یافت نشد.', noItems: 'چیزی برای نمایش وجود ندارد.' }"
            >
                
            <template #Rows="{index}">
                <td >
                    {{index+1}}
                </td>
            </template>
            <template #ST1="{item}">
                <td>
                    {{GetTime(item.ST1)}}
                </td>
            </template>
            <template #ST2="{item}">
                <td >
                    {{GetTime(item.ST2)}}
                </td>
            </template>
            <template #Edit="{item}">
                <td style="font-size: 16px">
                    <CButton   color="primary" @click="Edit(item)" >ویرایش</CButton>
                </td>
            </template>
            <template #Delete="{item}">
                <td>
                    <CButton  color="danger"  @click="DayDefine_DeletByID(item.DayDefineID)" >
                        حذف
                    </CButton>
                </td>
            </template>
                </CDataTable>
  
            </div>
            <div class="card-footer" style="direction:ltr;display: flex;gap:10px" >
                
                <MPrint :data="$store.state.DayDefine_GetAll.RequestResponse" label="PDF" title="عناوین روز" :fields=fields></MPrint>
            </div>
        </div>
        <CModal
                title=""
                color="info"
                :closeOnBackdrop="false"
                :size="'xl'"
                :show.sync="DialogAddDay"
        >
            <div style="direction: ltr;text-align: right">
                <CRow style="direction:rtl">
                    <CInput style="width:100%;max-width:300px;" v-model="txtDayName" label="عنوان روز"/>
                </CRow>
                <CRow style="direction:ltr">
                    <label style="width:100%;margin-bottom:10px;color:white" for="">بازه زمانی</label>
                   <div class="MultiRangeSliderContainer">
                        <MultiRangeSlider
                            :min="0"
                            :max="1440"
                            :minValue="hBarMinValue"
                            :maxValue="hBarMaxValue"
                            :labels="hoursLabel"
                            :min-caption="hoursMinCaption"
                            :max-caption="hoursMaxCaption"
                            :step="5"
                            @input="updateHoursValues"
                        />
                    </div>
                   
                </CRow>
                
                
            </div>
            <template #header>

                <h4 class="modal-title" style="direction: rtl"> <CIcon name="cil-sun" width="20px" height="20px"/>&nbsp;&nbsp; افزودن روز </h4>

            </template>
            <template #footer>
                <CButton @click="DialogAddDay = false" color="danger">انصراف</CButton>
                <CButton @click="DayDefine_Insert()" color="primary">&nbsp;&nbsp;افزودن</CButton>
            </template>
        </CModal>
        <CModal
                title=""
                color="info"
                :closeOnBackdrop="false"
                :size="'xl'"
                :show.sync="DialogEditDay"
        >
            <div style="direction: ltr;text-align: right">
                <CRow style="direction:rtl">
                    <CInput style="width:100%;max-width:300px;" v-model="txtDayName" label="ویرایش روز"/>
                </CRow>
                <CRow style="direction:ltr">
                    <label style="width:100%;margin-bottom:10px;color:white" for="">بازه زمانی</label>
                   <div class="MultiRangeSliderContainer" v-if="DialogEditDay">

                        <MultiRangeSlider
                        :min="0"
                        :max="1440"
                        :minValue="hBarMinValue2"
                        :maxValue="hBarMaxValue2"
                        :labels="hoursLabel"
                        :min-caption="hoursMinCaption2"
                        :max-caption="hoursMaxCaption2"
                        :step="5"
                        @input="updateHoursValues2"
                        />
                    </div>
                   
                </CRow>
                
                
            </div>
            <template #header>

                <h4 class="modal-title" style="direction: rtl"> <CIcon name="cil-sun" width="20px" height="20px"/>&nbsp;&nbsp; افزودن روز </h4>

            </template>
            <template #footer>
                <CButton @click="DialogEditDay = false" color="danger">انصراف</CButton>
                <CButton @click="DayDefine_Update()" color="primary">&nbsp;&nbsp;ذخیره</CButton>
            </template>
        </CModal>
    </div>
</template>
<script>
import MultiRangeSlider from "multi-range-slider-vue";

export default {
    data(){
        return{
            txtDayName:'',
            hBarMinValue: 120,
            hBarMinValue2: 120,
            hBarMaxValue: 600,
            hBarMaxValue2: 600,
            DayDefineID: 0,
            DialogAddDay:false,
            DialogEditDay:false,
            fields:[{"key":"Rows","label":"ردیف"},{"key":"Name","label":"عنوان"},{"key":"ST1","label":"از ساعت"},{"key":"ST2","label":"تا ساعت"},{"key":"Edit","label":"ویرایش"},{"key":"Delete","label":"حذف"}],
            
        }
    
    },
    computed:{
        ReadDayDefine_Insert(){
           return this.$store.state.DayDefine_Insert;
        },
        ReadDayDefine_Update(){
           return this.$store.state.DayDefine_Update;
        },
        hoursLabel() {
            let labels = [];
            for (let i = 0; i <= 24; i++) {
                labels.push(`${i.toString().length === 1 ? "0" : ""}${i}:00`);
            }
            return labels;
        },
        hoursMinCaption() {
            let h = Math.floor(this.hBarMinValue / 60);
            let m = this.hBarMinValue % 60;
            let hh = h.toString().length === 1 ? "0" : "";
            let mm = m.toString().length === 1 ? "0" : "";

            return `${hh}${h}:${mm}${m}`;
        },
        hoursMinCaption2() {
            let h = Math.floor(this.hBarMinValue2 / 60);
            let m = this.hBarMinValue2 % 60;
            let hh = h.toString().length === 1 ? "0" : "";
            let mm = m.toString().length === 1 ? "0" : "";

            return `${hh}${h}:${mm}${m}`;
        },
        hoursMaxCaption() {
            let h = Math.floor(this.hBarMaxValue / 60);
            let m = this.hBarMaxValue % 60;
            let hh = h.toString().length === 1 ? "0" : "";
            let mm = m.toString().length === 1 ? "0" : "";
            return `${hh}${h}:${mm}${m}`;
        },
        hoursMaxCaption2() {
            let h = Math.floor(this.hBarMaxValue2 / 60);
            let m = this.hBarMaxValue2 % 60;
            let hh = h.toString().length === 1 ? "0" : "";
            let mm = m.toString().length === 1 ? "0" : "";
            return `${hh}${h}:${mm}${m}`;
        },
    },
    watch:{
        ReadDayDefine_Insert(res){
            if(res.Status!==undefined){
                if(res.Status){
                    if(res.RequestResponse[0].Report==='Insert Success'){
                        this.DialogAddDay=false;
                        this.DayDefine_GetAll();
                        this.$store.commit('ShowToast',{type:'success',message:'عملیات با موفقیت انجام شد.'})
                    }
                    
                }
            }
        },
        ReadDayDefine_Update(res){
            if(res.Status!==undefined){
                if(res.Status){
                    if(res.RequestResponse[0].Message==='Successfully!'){
                        this.DialogEditDay=false;
                        this.DayDefine_GetAll();
                        this.$store.commit('ShowToast',{type:'success',message:'عملیات با موفقیت انجام شد.'})
                    }
                    
                }
            }
        },
    },
    components: {
        MultiRangeSlider
    },
    mounted(){
         this.DayDefine_GetAll();
    },
    methods:{
        UpdateValues(data){
            console.log(data)
        },
        DayDefine_GetAll(){
            this.$store.commit('DayDefine_GetAll');
            
        },
        DayDefine_Insert(){
            this.$store.commit('DayDefine_Insert',{
                Name:this.txtDayName,
                ST1:this.hBarMinValue,
                ST2:this.hBarMaxValue,
                ST3:0,
                ST4:0,
            }); 
        },
        DayDefine_Update(){
            this.$store.commit('DayDefine_Update',{
                DayDefineID:this.DayDefineID,
                Name:this.txtDayName,
                ST1:this.hBarMinValue2,
                ST2:this.hBarMaxValue2,
                ST3:0,
                ST4:0,
            }); 
        },
        DayDefine_DeletByID(id){
            this.$store.commit('DayDefine_DeletByID',{
                DayDefineID:id,
                
            }); 
        },
        FleetByUser(){
            this.$store.commit('FleetByUser');
        },
        updateHoursValues(e) {
            this.hBarMinValue = e.minValue;
            this.hBarMaxValue = e.maxValue;
        },
        updateHoursValues2(e) {
            this.hBarMinValue2 = e.minValue;
            this.hBarMaxValue2= e.maxValue;
        },
        Add(){
            this.DialogAddDay=true;
            this.DayDefineID=0;
            this.Name="";
            this.hBarMinValue=100
            this.hBarMaxValue=200
        },
        Edit(item){
            this.DayDefineID=item.DayDefineID;
            this.txtDayName=item.Name;
            this.hBarMinValue2=item.ST1
            this.hBarMaxValue2=item.ST2
            // console.log(this.hBarMinValue2)
            // console.log(this.hBarMaxValue2)
            var that=this;
            setTimeout(function() {
                that.DialogEditDay=true;
              }, 0);
            
        },
        GetTime(input) {
            var h=Math.floor(input/60);
            var m=input%60;
            if(h<10)
                h=('0'+h);
            if(m<10)
                m=('0'+m);
                
            return h+":"+m;
        },
    }
}
</script>
<style scoped>

@import "./../../../node_modules/multi-range-slider-vue/MultiRangeSliderBlack.css";
@import "./../../../node_modules/multi-range-slider-vue/MultiRangeSliderBarOnly.css";
</style>